import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const ResourceCenterMenuContainer = styled.div`
  max-width: 100vw !important;
  display: grid;
  position: relative;
  z-index: 2;
  background: ${palette.sierraRain};
`

export const ResourceCenterMenuLinksMobile = styled.div`
  display: none;
  height: 64px;
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  justify-content: space-around;
  color: ${palette.white};

  @media all and (max-width: ${layout.lg}) {
    display: grid;
  }
`

export const ResourceCenterMenuLinks = styled.div`
  display: flex;
  height: 64px;
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  justify-content: space-around;
  color: ${palette.white};

  @media all and (max-width: ${layout.lg}) {
    display: none;
  }
`

export const ResourceCenterMenuLinkGroup = styled.div`
  position: relative;
  background: ${palette.sierraRain};
  display: grid;
  z-index: 10;
  background: ${palette.sierraRain};

  a {
    color: ${palette.white};
    text-decoration: none;
    align-self: center;
    justify-self: center;
    padding: 1.40rem .5rem;
  }

  &:hover {
    color: ${palette.text};
    background: ${palette.lightSierraRain};

    a {
      color: ${palette.text};
    }
    & > div {
      display: block;
    }
  }

  @media all and (max-width: ${layout.lg}) {
    position: absolute;
    width: 100%;
    text-align: center;

    a {
      width: 100%;
    }
  }
`

export const ResourceCenterMenuLinkSubGroup = styled.div<{ orientation?: 'left' | 'right' }>`
  top: 100%;
  ${({ orientation }) => orientation === 'left' ? 'right: 0px' : 'left: 0px'};
  display: none;
  position: absolute;
  width: max-content;
  max-width: 350px;
  background: ${palette.lightSierraRain};

  a {
    color: ${palette.text};
    text-decoration: none;
    align-self: center;
    justify-content: space-between;


    padding: 1.375rem 1.25rem;
    display: flex;

    ${({ orientation }) => orientation === 'left' ? '&:before' : '&:after'}{
      content: "";
      display: block;
      background-image: ${({ orientation }) => orientation === 'left' ? 'url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSIxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNS44NjggMS41NTdMMi4xNTIgN2wzLjcxNiA1LjQ0M2MuMjc0LjQwMi4xMDguOTEzLS4zNzIgMS4xNDItLjQ4LjIzLTEuMDkuMDktMS4zNjQtLjMxMWwtNC01Ljg1OWEuNzIuNzIgMCAwMTAtLjgzbDQtNS44NTljLjI3NC0uNDAxLjg4NS0uNTQgMS4zNjQtLjMxMS40OC4yMjkuNjQ2Ljc0LjM3MiAxLjE0MnoiIGZpbGw9IiMyRDI2M0IiLz48L3N2Zz4=)' : 'url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSIxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNLjEzMiAxMi40NDRMMy44NDggNyAuMTMyIDEuNTU3Qy0uMTQyIDEuMTU1LjAyNS42NDQuNTA0LjQxNWMuNDgtLjIzIDEuMDktLjA5IDEuMzY0LjMxMWw0IDUuODU5YS43Mi43MiAwIDAxMCAuODNsLTQgNS44NTljLS4yNzQuNDAxLS44ODQuNTQtMS4zNjQuMzExLS40OC0uMjI5LS42NDYtLjc0LS4zNzItMS4xNDJ6IiBmaWxsPSIjMkQyNjNCIi8+PC9zdmc+)'};
      background-position: 50%;
      background-repeat: no-repeat;
      background-size: 6px 14px;
      width: 6px;
      height: 14px;
      ${({ orientation }) => orientation === 'left' ? 'margin-right: 20px;' : 'margin-left: 20px;'};
      margin-top: 2px;
      transition: -webkit-transform .3s;
      transition: transform .3s;
      transition: transform .3s,-webkit-transform .3s;
    }
  }
`

export const ResourceCenterMenuLinkSubEntry = styled.div`
  position: relative;

  &:hover {
    & > a {
      text-decoration: underline;
      &:after{
        transform: translateX(5px);
      }
      &:before{
        transform: translateX(-5px);
      }
    }
    & > div {
      display: block;
    }
  }
`

export const ResourceCenterMenuLinkPost = styled.div<{ orientation?: 'left' | 'right' }>`
top: 0px;
${({ orientation }) => orientation === 'left' ? 'right: 100%' : 'left: 100%'};
position: absolute;
display: none;
width: max-content;
max-width: 350px;
background: ${palette.lightSierraRain};

a {
  color: ${palette.text};
  text-decoration: none;
  align-self: center;  
  justify-self: ${({ orientation }) => orientation === 'left' ? 'end' : 'start'};
  padding: 1.375rem 0.5rem 1.375rem 1rem;

  &:before, &:after {
    display: none;
  }
}
`
